import { render, staticRenderFns } from "./AdminActionsPage.vue?vue&type=template&id=eb84dcde&scoped=true&"
import script from "./AdminActionsPage.vue?vue&type=script&lang=js&"
export * from "./AdminActionsPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminActionsPage.vue?vue&type=style&index=0&id=eb84dcde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb84dcde",
  null
  
)

export default component.exports